import { getToken } from "../../services/HttpService"

export const getRequestBeneficiary = async ({ pageNumber, pageSize } = {}) => {
    const response = await getToken();
    const params = new URLSearchParams();
    if (pageNumber) params.append('pageNumber', pageNumber);
    if (pageSize) params.append('pageSize', pageSize);
    const query = params.toString() ? `?${params.toString()}` : '';
    const resp = await fetch(
        `${process.env.REACT_APP_API}/list/beneficiary/transfer/request${query}`,
        {
            headers: {
                "Authorization": `Bearer ${response.token}`,
                "token": localStorage.getItem("token") || ""
            },
            redirect: "follow"
        }
    )
    return await resp.json()
}

export const getRequestBeneficiaryFiltered = async ({ userFilter, dateFilter, stateFilter, pageNumber, pageSize } = {}) => {
    const response = await getToken();
    const params = new URLSearchParams();
    if (userFilter) params.append('userFilter', userFilter);
    if (dateFilter) params.append('dateFilter', dateFilter);
    if (stateFilter) params.append('stateFilter', stateFilter);
    if (pageNumber) params.append('pageNumber', pageNumber);
    if (pageSize) params.append('pageSize', pageSize);
    const query = params.toString() ? `?${params.toString()}` : '';
    const url = `${process.env.REACT_APP_API}/list/beneficiary/transfer/request${query}`;
    // DEBUG: imprimir token y URL para diagnosticar headers faltantes
    // eslint-disable-next-line no-console
    console.log('getRequestBeneficiaryFiltered -> url:', url);
    // eslint-disable-next-line no-console
    console.log('getRequestBeneficiaryFiltered -> token:', response && response.token);
    const resp = await fetch(
        url,
        {
            headers: {
                "Authorization": `Bearer ${response.token}`,
                "token": localStorage.getItem("token") || ""
            },
            redirect: "follow"
        }
    )
    return await resp.json()
}

export const getRequestBeneficiaryById = async (requestId) => {
    const response = await getToken();
    const resp = await fetch(
        `${process.env.REACT_APP_API}/get/beneficiary/transfer/request/by/id?requestId=${requestId}`, {
        headers: {
            "Authorization": `Bearer ${response.token}`
        }
    }
    )
    return await resp.json()
}

export const getPaginationRequest = async (pageSize, lastpaginationToken) => {
    const response = await getToken();
    const resp = await fetch(
        `${process.env.REACT_APP_API}/list/beneficiary/transfer/request?pageSize=${pageSize}${lastpaginationToken ? '&paginationToken=' + lastpaginationToken : ''}`, {
        headers: {
            "Authorization": `Bearer ${response.token}`,
            "token": localStorage.getItem("token") || ""
        }
    }
    )
    return await resp.json()
}

export const putRequestBeneficiary = async (data) => {
    const endPoint = `${process.env.REACT_APP_API}/accepted-or-rejected/beneficiary/transfer/request`;

    const response = await getToken();
    const resp = await fetch(endPoint, {
        headers: {
            Authorization: `Bearer ${response.token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data),
        method: 'PUT',
        redirect: "follow"
    })

    return await resp.json();
}